//utility class for time related functions

import { toLower } from "lodash";

export default class StringUtils {
  // list of fields that should be capitalized
  static fieldsToCapitalize = [
    "first_name",
    "middle_name",
    "last_name",
    "gender",
    "address",
    "district",
    "hometown",
    "state",
    "country",
    "em_first_name",
    "em_last_name",
    "em_relationship",
    "em_relation",
    "em_address"
  ];

  //capitalize first letter of all words in a string
  static capitalize = (str) => {
    if (!str || typeof str !== "string") return str;
    return str
      .split(" ")
      .map((word) => word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : "")
      .join(" ");
  }

  //capitalize the specific string fields in an object
  static capitalizeObjectFields = (obj) => {
    if (!obj) return obj;
    const newObj = { ...obj };
    StringUtils.fieldsToCapitalize.forEach((field) => {
      if (newObj[field] !== undefined && newObj[field] !== null) {
        newObj[field] = StringUtils.capitalize(newObj[field]);
      }
    });
    return newObj;
  };

  //check if string conatins substring
  static contains = (str, subStr) => {
    return str.toLowerCase().indexOf(subStr.toLowerCase()) !== -1;
  }
}
